module.exports = __webpack_public_path__ + "static/media/nodejs.a1231528.svg";